import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import style from "./favourite.module.scss";
import {
  resetStateForNavigation,
  selectMPSTopicFile,
  updateState,
} from "../../features/counter/counterSlice";
import classNames from "classnames";
import PropTypes from "prop-types";
import icons from "../../scss/guidelineicons.module.scss";
import { DRUG_INDEX_FAVOURITE_TYPE } from "../FavouriteButton/favouritesService";

const Favourite = ({ title, url, type, guideline, removeFavourite, sectionId }) => {
  const dispatch = useDispatch();
  const mpstopicfile = useSelector(selectMPSTopicFile);
  const topicDetailsFromMps = mpstopicfile?.[guideline] || {};
  const isDrugIndexFavourite = type === DRUG_INDEX_FAVOURITE_TYPE;
  const listLabel = isDrugIndexFavourite ? "Drug index" : topicDetailsFromMps?.text;

  const handleClick = () => {
    dispatch(updateState({ XRefPath: "" }));
    dispatch(resetStateForNavigation());
    if (sectionId) {
      dispatch(updateState({ XRefPath: sectionId }));
    }
  };

  return (
    <div className={classNames("size-14", style.favouriteContainer)}>
      <Link className={style.favouriteLink} to={url} onClick={handleClick}>
        <div>
          {isDrugIndexFavourite ? (
            <span className={classNames(style.squareIcon, style.drugIconContainer)}>
              <i className={classNames("tg-icons-Drug", style.drugIcon)}></i>
            </span>
          ) : (
            <span
              className={classNames(icons[topicDetailsFromMps.squareIconClass], style.squareIcon)}
            ></span>
          )}
        </div>
        <div className={style.favouriteText}>
          {listLabel && <div className="size-12">{listLabel}</div>}
          <div>{title}</div>
        </div>
      </Link>
      <div className={style.removeFavouriteSection}>
        <button
          className={style.removeFavouriteButton}
          type="button"
          onClick={() => removeFavourite(title, url, type, guideline)}
          data-testid="crossButton"
        >
          <i className="tg-icons-Cross size-24"></i>
        </button>
      </div>
    </div>
  );
};

Favourite.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  guideline: PropTypes.string,
  removeFavourite: PropTypes.func.isRequired,
};

export default Favourite;
